import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/marketing-discount-batch/constants'

const propTypes = {
  status: PropTypes.string
}

/**
 * To give nice look on `marketing_discount_status`.
 * It maps `status` to certain style and pass to `StatusBadge`.
 * @param {string} status Product status. available values
 * - scheduled
 * - cancelled
 * - live
 * - expired
 */

const MarketingDiscountBatchStatusBadge = ({ status }) => {
  const colorMap = {
    [ STATUS.SCHEDULED ] : 'primary',
    [ STATUS.CANCELLED ] : 'danger',
    [ STATUS.LIVE ]      : 'success',
    [ STATUS.EXPIRED ]   : 'secondary',
    [ STATUS.REVERTED ]  : 'danger'
  }

  const color = colorMap[status]

  return <StatusBadge color={ color } label={ status } />
}

MarketingDiscountBatchStatusBadge.propTypes = propTypes

export default MarketingDiscountBatchStatusBadge
